const promiseStatuses = Object.freeze({
  FULFILLED: 'fulfilled',
  REJECTED: 'rejected'
})

/**
 *
 * @returns {Promise<{rejected, resolved}>}
 */
const splitAndSettlePromises = async (promises) => {
  const settledPromises = await Promise.allSettled(promises)

  const resolved = settledPromises
    .filter((promise) => promise.status === promiseStatuses.FULFILLED)
    .map((promise) => promise.value)

  const rejected = settledPromises
    .filter((promise) => promise.status === promiseStatuses.REJECTED)
    .map((promise) => promise.reason)

  return {
    resolved,
    rejected
  }
}

module.exports = {
  splitAndSettlePromises
}
